module.exports = __webpack_public_path__ + "5450e83047435db8b0ca11da9a723373.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/beard-santa.png
// module id = 2306
// module chunks = 0